module.exports = __webpack_public_path__ + "img/paisajeaboutusdesktop.254c0c9e.jpg";